<div class="faq-page">
  <header class="faq-page__header">
    <h1 class="faq-page__heading">Coverpath FAQs</h1>
  </header>

  <div class="faq-page__main-content">
    <section class="faq">
      <div class="faq__topics">
        <h2 class="faq__heading">Topics</h2>
        <ul class="faq-navigation">
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('about')">About MassMutual</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('term')">Convertible Term Insurance</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('whole')">Whole Life Insurance</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('help')">How We Can Help</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('apply')">Your Application</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('after')">After You Apply</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('temporary-coverage')">
              Temporary Coverage
            </button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('payments')">Payments</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('policy')">Your Policy</button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('change-policy')">
              Changing Your Policy
            </button>
          </li>
          <li class="faq-navigation__item">
            <button class="faq-navigation__link" (click)="scrollToElement('claims')">Claims</button>
          </li>
        </ul>
      </div>

      <div class="faq__questions">
        <h2 class="faq__heading">Popular Questions</h2>

        <section class="faq__section" id="about">
          <a name="about">
            <h2 class="faq__section-title">About MassMutual</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">What is MassMutual?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company (MassMutual) is an insurance company that issues life
                insurance policies. Ever since we were founded on May 15, 1851, we've had a single purpose: to help
                people secure their future and protect the ones they love. More than 167 years later, that commitment
                remains our guiding principle. It's behind everything we do and every decision we make. It's how we
                continue to deliver products and services to help our policy owners and customers achieve their
                financial goals, and protect those who matter most.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What makes MassMutual different?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                MassMutual now gives you an incredible opportunity to purchase a fully underwritten convertible term or
                whole life insurance policy online. With our online tools, you can calculate your own needs, fill out an
                application and purchase a MassMutual Convertible Term policy, if all is in good order, while also
                having the guidance of {{ singularAdvisorDescriptiveNoun }} at any time during the process and beyond to
                help you with your broader financial needs.
              </p>
              <p class="faq-item__body-text">
                If you wish to purchase whole life insurance, speak with your {{ advisorDescriptiveNoun }} who will help
                you determine your needs and create an online quote and illustration so you can visualize your policy’s
                value over time. Then, when you’re ready, fill out the online application at your own convenience.
              </p>
              <p class="faq-item__body-text">
                Previously, you could calculate your needs and receive a quote online, but after that, your application
                would be sent through traditional channels or through a call center process. That process usually took
                between four and six weeks. Now, when you've submitted a MassMutual Convertible Term application online,
                you may get an immediate decision and coverage may begin right away.
              </p>
              <p class="faq-item__body-text">
                Additionally, we believe you shouldn't need a dictionary to read your life insurance policy.
                MassMutual's policies are in plain language so that they're easy to read and you can understand your
                coverage.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Does MassMutual offer both term and whole life insurance?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, MassMutual does offer both term and whole life insurance through our online Coverpath platform...
                If you’re interested in purchasing whole life insurance, you can work with
                {{ singularAdvisorDescriptiveNoun }} who will provide you with a digital life insurance illustration and
                quote, then fill out your application online.
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="term">
          <a name="term">
            <h2 class="faq__section-title">Convertible Term Insurance</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">
              What is MassMutual's Convertible Term policy and how does it work?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                MassMutual's Convertible Term policy is designed to give you the security of death benefit coverage for
                a specified time period and the flexibility to convert that coverage into a whole life policy that
                provides lifetime protection at an affordable rate. Because this particular policy is algorithmically
                underwritten, it can be applied for online and approved in real-time. In other words, you receive an
                immediate decision and coverage can begin right away.* In order to continue the coverage, you do need to
                complete a medical exam within 90 days. Then, for a period of 2 years up to 10 years, depending on your
                age, MassMutual's convertible term insurance gives you the right to convert all or a portion of your
                policy to a permanent policy that offers you lifetime protection and other benefits at an affordable
                rate.
              </p>
              <p class="faq-item__body-text">*For healthy, qualified individuals</p>
              <p class="faq-item__body-text">
                While convertibility might not be for everyone, we believe in empowering you with options and
                flexibility as your needs and circumstances change. If you have children, a partner, or elderly parents
                that need financial protection immediately, but you can't afford the higher premiums of lifetime
                protection through a whole life policy, a convertible term could be a great solution to solving your
                immediate need but also keeping the option to switch to a lifetime protection at an affordable rate in
                the future as your financial circumstances stabilize or improve.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              Is this convertible term product the same quality as what I'd receive going through the traditional
              process?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Absolutely. The fact that you are purchasing online and receiving an immediate decision doesn't change
                anything about the quality of the policy you are getting. This Convertible Term policy is issued by
                MassMutual, which is rated A++ by AM Best*. MassMutual has also received high financial strength ratings
                from other rating agencies. MassMutual’s exceptional financial strength is underscored by ratings that
                are among the highest of any company in any industry.
              </p>
              <p class="faq-item__body-text">
                Purchasing online also doesn't change the level of customer service you will receive. We have customer
                service representatives available to help via email or phone (DigitalCustomerSupport@massmutual.com or
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                ) throughout the application process.
              </p>
              <p class="faq-item__body-text">
                *Financial strength ratings are as of June 4, 2019 and are subject to change. A.M. Best Company: A++;
                Fitch Ratings: AA+; Moody’s Investors Service: Aa3; Standard & Poor’s: AA+. Ratings are for
                Massachusetts Mutual Life Insurance Company (MassMutual), Springfield, MA 01111-0001, and its
                subsidiaries, C.M. Life Insurance Company and MML Bay State Life Insurance Company, Enfield, CT 06082.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              What states are MassMutual convertible term products available in?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Currently, we offer convertible term life insurance policies to residents of the following states:
              </p>
              <ul class="faq__list">
                <li>Alabama</li>
                <li>Alaska</li>
                <li>Arizona</li>
                <li>Arkansas</li>
                <li>California</li>
                <li>Colorado</li>
                <li>Connecticut</li>
                <li>Delaware</li>
                <li>District if Columbia</li>
                <li>Florida</li>
                <li>Georgia</li>
                <li>Hawaii</li>
                <li>Idaho</li>
                <li>Illinois</li>
                <li>Indiana</li>
                <li>Iowa</li>
                <li>Kansas</li>
                <li>Kentucky</li>
                <li>Louisiana</li>
                <li>Maine</li>
                <li>Maryland</li>
                <li>Massachusetts</li>
                <li>Michigan</li>
                <li>Minnesota</li>
                <li>Mississippi</li>
                <li>Missouri</li>
                <li>Montana</li>
                <li>Nebraska</li>
                <li>Nevada</li>
                <li>New Hampshire</li>
                <li>New Jersey</li>
                <li>New Mexico</li>
                <li>North Carolina</li>
                <li>North Dakota</li>
                <li>Ohio</li>
                <li>Oklahoma</li>
                <li>Oregon</li>
                <li>Pennsylvania</li>
                <li>Rhode Island</li>
                <li>South Carolina</li>
                <li>South Dakota</li>
                <li>Tennessee</li>
                <li>Texas</li>
                <li>Utah</li>
                <li>Vermont</li>
                <li>Virginia</li>
                <li>Washington</li>
                <li>West Virginia</li>
                <li>Wisconsin</li>
                <li>Wyoming</li>
              </ul>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I know when my policy can be converted?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                You will see an eligibility deadline date in your policy packet or check your account center for easy
                reference. You can convert all or a portion of your policy (within limits) into a whole life policy
                anytime before this date.
              </p>
              <p class="faq-item__body-text">
                If you do not see a date displayed, then the window to convert your policy has already expired. This
                timeframe ranges from a minimum of 2 years up to 10 years, depending on your age.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I convert my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Conversion can be a complicated topic, which is why it's important to work with your a financial
                professional to figure out which whole life policy might be best for you. Once you've made a decision,
                your financial professional will guide you through the process of completing the conversion of all, or a
                portion, of your convertible term policy into a whole life policy.
              </p>
            </div>
          </details>
          <details class="faq-item">
            <summary class="faq-item__question">What if I want a longer conversion period?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                There is an optional Extended Conversion Period (ECP) available with certain MassMutual Direct Term life
                insurance policy term lengths. This provides you with the ability to have a longer conversion time frame
                beyond the standard base policy at an additional cost. The extended conversion timeframe is more
                expensive and only available for certain ages. For example 15 ECP will be convertible for 15 years,
                while ECP versions of 20, 25, and 30 will be convertible for 20 years for individuals age 18-54 or 18-45
                for tobacco classes. Check out the calculator to determine the cost difference and conversion time frame
                that is right for you. There is an optional Extended Conversion Period (ECP) available with certain term
                lengths.
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="whole">
          <a name="term">
            <h2 class="faq__section-title">Whole Life Insurance</h2>
          </a>
          <details class="faq-item">
            <summary class="faq-item__question">
              Is this whole life product the same quality as what I'd receive going through the traditional process?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Absolutely. The fact that you are purchasing online and receiving an immediate decision doesn't change
                anything about the quality of the policy you are getting. This Convertible Term policy is issued by
                MassMutual, which is rated A++ by AM Best*. MassMutual has also received high financial strength ratings
                from other rating agencies. MassMutual’s exceptional financial strength is underscored by ratings that
                are among the highest of any company in any industry.
              </p>
              <p class="faq-item__body-text">
                Purchasing online also doesn't change the level of customer service you will receive. We have customer
                service representatives available to help via email or phone (DigitalCustomerSupport@massmutual.com or
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                ) throughout the application process.
              </p>
              <p class="faq-item__body-text">
                *Financial strength ratings are as of June 4, 2019 and are subject to change. A.M. Best Company: A++;
                Fitch Ratings: AA+; Moody’s Investors Service: Aa3; Standard & Poor’s: AA+. Ratings are for
                Massachusetts Mutual Life Insurance Company (MassMutual), Springfield, MA 01111-0001, and its
                subsidiaries, C.M. Life Insurance Company and MML Bay State Life Insurance Company, Enfield, CT 06082.
              </p>
            </div>
          </details>
          <details class="faq-item">
            <summary class="faq-item__question">What is MassMutual's Whole Life policy and how does it work?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                MassMutual’s Whole life insurance is a permanent policy, which gives you guaranteed protection for your
                loved ones that can last a lifetime. With whole life insurance, unlike term, the policy has a guaranteed
                cash value, which you can use however you want*. Participating whole life insurance is eligible to
                receive dividends, which can increase the death benefit and the cash value. Dividends are not
                guaranteed. Or there are other options you could choose, such as using dividends to help pay premiums.
                Because this particular policy is algorithmically underwritten, it can be applied for online and
                approved in real-time. In other words, you may receive an immediate decision and coverage can begin
                right away.** In order to continue the coverage, you do need to complete a medical exam.
              </p>
              <p class="faq-item__body-text">
                *Access to cash values through borrowing or partial surrenders will reduce the policy’s cash value and
                death benefit, increase the chance the policy will lapse, and may result in a tax liability if the
                policy terminates before the death of the insured.
              </p>
              <p class="faq-item__body-text">**For healthy, qualified individuals</p>
              <p class="faq-item__body-text">
                Whole Life may not be suitable for everyone and every financial plan. To learn more about our Whole Life
                products, please speak with your {{ advisorDescriptiveNoun }}.
              </p>
            </div>
          </details>
          <details class="faq-item">
            <summary class="faq-item__question">What states is our Whole Life product available in?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Currently, we offer whole life insurance policies to residents of the following states:
              </p>
              <ul class="faq__list">
                <li>Alabama</li>
                <li>Alaska</li>
                <li>Arizona</li>
                <li>Arkansas</li>
                <li>California</li>
                <li>Colorado</li>
                <li>Connecticut</li>
                <li>Delaware</li>
                <li>District if Columbia</li>
                <li>Florida</li>
                <li>Georgia</li>
                <li>Hawaii</li>
                <li>Idaho</li>
                <li>Illinois</li>
                <li>Indiana</li>
                <li>Iowa</li>
                <li>Kansas</li>
                <li>Kentucky</li>
                <li>Louisiana</li>
                <li>Maine</li>
                <li>Maryland</li>
                <li>Massachusetts</li>
                <li>Michigan</li>
                <li>Minnesota</li>
                <li>Mississippi</li>
                <li>Missouri</li>
                <li>Montana</li>
                <li>Nebraska</li>
                <li>Nevada</li>
                <li>New Hampshire</li>
                <li>New Jersey</li>
                <li>New Mexico</li>
                <li>North Carolina</li>
                <li>North Dakota</li>
                <li>Ohio</li>
                <li>Oklahoma</li>
                <li>Oregon</li>
                <li>Pennsylvania</li>
                <li>Rhode Island</li>
                <li>South Carolina</li>
                <li>South Dakota</li>
                <li>Tennessee</li>
                <li>Texas</li>
                <li>Utah</li>
                <li>Vermont</li>
                <li>Virginia</li>
                <li>Washington</li>
                <li>West Virginia</li>
                <li>Wisconsin</li>
                <li>Wyoming</li>
              </ul>
            </div>
          </details>
        </section>

        <section class="faq__section" id="help">
          <a name="help">
            <h2 class="faq__section-title">How We Can Help</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">How can MassMutual help me with the application process?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                We have multiple resources available to assist you in selecting and purchasing the right term life
                insurance policy:
              </p>
              <ul class="faq__list">
                <li>
                  If you need any help during your application process, our customer service team is available to answer
                  any questions you may have.
                </li>
                <li>
                  And finally your {{ advisorDescriptiveNoun }} will be available throughout the process to provide any
                  guidance as well as help you plan for broader needs.
                </li>
              </ul>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Will customer service be available to assist me?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, we're here and eager to help make sure you have a great experience navigating our website and going
                through our application process. Our customer service representatives will be available during business
                hours both via phone (
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                ) and live chat. Our business hours are Monday–Friday, 9am–6pm ET.
              </p>
              <p class="faq-item__body-text">
                If you need assistance after business hours, take a look through this list of commonly asked questions
                to see if we might have an answer here for you, or you can send an email to our Customer service team at
                <a href="mailto:DigitalCustomerSupport@massmutual.com">DigitalCustomerSupport@massmutual.com</a>
                .
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              How is {{ singularAdvisorDescriptiveNoun }} involved in this process?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Your trusted {{ advisorDescriptiveNoun }} is here to listen and make sure that all of your life
                insurance questions get answered. Together you can develop insurance strategies that are best suited to
                your needs.
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="apply">
          <a name="apply">
            <h2 class="faq__section-title">Your Application</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">What information do I need in order to apply?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                To apply for a MassMutual Convertible Term or Whole Life policy, you'll need to be ready to provide the
                following:
              </p>
              <ul class="faq__list">
                <li>Your personal information including your Social Security number</li>
                <li>Your financial information, including salary and existing debt</li>
                <li>Lifestyle and health history information</li>
                <li>Your spouse's age and income</li>
                <li>Contact information for your primary care physician</li>
                <li>
                  Names of your beneficiaries along with their Social Security numbers, dates of birth, and addresses
                </li>
              </ul>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What if I don't have a Social Security Number?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                In order to apply for a MassMutual Convertible Term or Whole Life policy you must be a U.S citizen and
                have a Social Security number.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              What is a beneficiary? And what is the difference between Primary and Alternate?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                A beneficiary is a person or parties that would receive proceeds in the event of the insured's death. It
                is best to be specific and up-to-date to avoid proceeds going to an estate where it can be tied up
                versus an immediate payout. The types of beneficiary are:
              </p>
              <ul class="faq__list">
                <li>
                  Primary: In the event of the insured's death, all death benefits will be given first to the primary
                  beneficiary or beneficiaries. When selecting multiple beneficiaries you will need to assign a weight
                  between 0-100%. Be sure the total adds up to 100% all together.
                </li>
                <li>
                  Alternate/Contingent: In the event of the insured's death where no primary beneficiaries are alive to
                  receive the benefit, then the benefit will go to contingent beneficiaries. Again, you can assign
                  multiple beneficiaries with multiple weights. Just make sure the total adds up to 100% all together.
                </li>
              </ul>
              <p class="faq-item__body-text">
                It is recommended to name both primary and alternate beneficiaries to avoid death benefits going to an
                estate where it may be subject to estate taxes and a delay in disbursing money.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              In the event that my primary or alternate beneficiary were to die before me, should the amount they would
              have received be divided among their descendants?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">What does this mean?</p>
              <p class="faq-item__body-text">
                The beneficiary section in the application may be confusing. Let's try and clarify and give you
                additional insight around beneficiary designations.
              </p>
              <p class="faq-item__body-text">Really, there are two ways to distribute the death benefit:</p>
              <ol>
                <li>
                  "Per Capita" which is a Latin term that literally means "by the head." According to this, in the event
                  of the insured's death all listed beneficiaries will receive equal share of the death benefit. Which
                  means, if a beneficiary dies before the insured then his/her share will go to the other listed
                  beneficiaries.
                </li>
                <li>
                  "Per Stirpes" is a Latin term that means "by the branch." According to this, if a beneficiary dies
                  before the insured, his/her descendants will receive their share, instead of it going to other named
                  beneficiaries.
                </li>
              </ol>
              <p class="faq-item__body-text">
                Here's an example: Jim, the insured, has three children: Sally, John, and Chris, who are listed as his
                primary beneficiaries. If Jim dies, his children will each receive equal shares of the death benefit
                (33.3% each).
              </p>
              <p class="faq-item__body-text">What happens if the daughter, Sally, dies before Jim?</p>
              <p class="faq-item__body-text">
                Under the "Per Capita" method, Sally's children would receive NOTHING. Instead, Sally's share will be
                split between John and Chris (50% each).
              </p>
              <p class="faq-item__body-text">
                Under the "Per Stirpes" method, Sally's children would receive her share of 33.3%, and John and Chris
                would receive their 33.3% as well.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Can I change or add beneficiaries at a later stage?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, whenever a significant life event happens, we recommend reviewing your beneficiaries to make sure
                they are up-to-date. If you want to change your beneficiary, you can do so through your Account Center.
                Take a look at the “Changing Your Policy” section of our FAQs for detailed instructions.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What is a Waiver of Premium?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                A disability waiver of premium rider is available, at an additional cost, if you are between the ages of
                18 through 59. This rider states that if you become totally disabled either from illness or injury, you
                don't have to pay premiums for the duration of the disability (once you show disability for longer than
                6 months, you will receive a full refund from the date of disability). If you feel you would be in
                danger of not being able to afford the premium if you become disabled, you should consider this option.
              </p>
              <p class="faq-item__body-text">
                “Total disability” is the incapacity of the Insured that: (A) is caused by sickness or injury; (B)
                begins while this rider is in full force; (C) for the first 60 months of any period of total disability,
                prevents the Insured from performing the substantial and material duties of the Insured’s occupation;
                and (D) after total disability has continued for 60 months, prevents the insured from performing any of
                the substantial and material duties of his or her job or any other job for which the Insured may become
                reasonably suited by education, training or experience.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What countries are considered in Western Europe?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Below are the countries that are part of Western Europe when answering the question: "Will your travel
                be limited to Western Europe, Australia, Japan, South Korea, Canada, New Zealand or Israel (excluding
                Gaza and the West Bank)?"
              </p>
              <div class="row no-gutters col-list">
                <ul class="faq__list">
                  <li>Andorra</li>
                  <li>Austria</li>
                  <li>Azores</li>
                  <li>Belgium</li>
                  <li>Canary Islands</li>
                  <li>Croatia</li>
                  <li>Cyprus</li>
                  <li>Czech Republic</li>
                  <li>Denmark</li>
                  <li>Finland</li>
                  <li>France</li>
                  <li>Germany</li>
                  <li>Greece</li>
                  <li>Greenland</li>
                  <li>Holland</li>
                  <li>Hungary</li>
                  <li>Iceland</li>
                  <li>Ireland</li>
                  <li>Italy</li>
                  <li>Liechtenstein</li>
                  <li>Luxembourg</li>
                  <li>Madeira</li>
                  <li>Malta</li>
                  <li>Monaco</li>
                  <li>Netherlands</li>
                  <li>Northern Ireland</li>
                  <li>Norway</li>
                  <li>Poland</li>
                  <li>Portugal</li>
                  <li>San Marino</li>
                  <li>Slovakia</li>
                  <li>Slovenia</li>
                  <li>Spain</li>
                  <li>Sweden</li>
                  <li>Switzerland</li>
                  <li>United Kingdom</li>
                </ul>
              </div>
            </div>
          </details>
        </section>

        <section class="faq__section" id="after">
          <a name="after">
            <h2 class="faq__section-title">After You Apply</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">What happens after I complete my application?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Once you submit the application, our system populates all your answers into an electronic document for
                you to easily review and digitally sign. That's right — no more having to print and fax in documents.
              </p>
              <p class="faq-item__body-text">Simply follow the below steps:</p>
              <ol>
                <li><p class="faq-item__body-text">Click the “eSign” button on your account page</p></li>
                <li>
                  <p class="faq-item__body-text">
                    Check your email — you should receive a Docusign link which will take you to your filled out
                    application
                  </p>
                </li>
                <li>
                  <p class="faq-item__body-text">
                    Enter the last 4 digits of your Social Security number to gain access
                  </p>
                </li>
                <li><p class="faq-item__body-text">Review and eSign it!</p></li>
              </ol>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              What should I do if I completed the application, but I still haven't received the eSign email?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Once you submit the application, our system populates all your answers into an electronic document for
                you to easily review and digitally sign.
              </p>
              <p class="faq-item__body-text">
                If you have submitted the application, and have not yet received an email from MassMutual via DocuSign,
                verify the email address by following the below steps:
              </p>
              <ol>
                <li>Click on the “Resend the eSign email” link.</li>
                <li>
                  Verify that the email address on the screen is correct. Please select the “Edit” link if you need to
                  make a change.
                </li>
                <li>Enter in account password.</li>
                <li>Click on “Resend To These Emails.”</li>
                <li>Check your email account for the eSign email from MassMutual via DocuSign.</li>
              </ol>
              <p class="faq-item__body-text">
                If the email you originally entered was correct, please check your email spam folder. Please contact us
                if you still did not receive this email.
              </p>
            </div>
          </details>

          <details class="faq-item" *ngIf="allowReapply">
            <summary class="faq-item__question">
              What should I do if I accidentally entered incorrect information?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                What's great about this new process is that we make it so easy to reapply. We save all your information,
                so it is as simple as cancelling one application, going back to the application, changing just the
                incorrect information and applying again. All your previous information will remain intact. In order to
                avoid people abusing this service, we do limit the number of applications submitted on the same insured
                to two times within any six month period, so please be sure to answer it accurately.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Why do I need to take a medical exam?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                We use your medical exam, along with other information, to help us determine your level of health and
                your rate class, which will determine your premium amount. Each life insurance company has multiple rate
                classes that determine the risk you represent to the company, and, thus, your premium amount. It&rsquo;s
                important that you're honest on your application and during the medical exam. If the insurer discovers
                that you were dishonest during any part of the application process, you may end up with an unexpected
                premium amount or the company deciding not to provide you with coverage.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How does the medical exam work?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The medical exam is designed to be as convenient as possible for you. A trained medical representative
                will come to either your home or your office, or you can go to any Quest Labs location. There are lots
                of great articles online that can help you prepare for the medical exam &mdash; but here are a few
                things to keep in mind:
              </p>
              <p class="faq-item__body-text">What to expect:</p>
              <ul>
                <li>
                  The exam will take about 30 minutes, and the paramed can meet you at your home, your place of
                  business, or the exam office. The paramed will review your family's medical history, measure your
                  blood pressure, height, and weight, collect blood and urine samples, and verify the health and
                  lifestyle claims you've made on your application. Things that could negatively impact your premium
                  include: high blood pressure, high BMI, high cholesterol or glucose levels, and indications of
                  nicotine, tobacco, or drug use.
                </li>
              </ul>
              <p class="faq-item__body-text">How to prepare:</p>
              <ul>
                <li>
                  In the weeks leading up to the exam, we recommend avoiding processed foods and sticking to leafy
                  greens, nuts, and other foods that improve your blood pressure and cholesterol levels. 24 hours before
                  the day of your exam, it's a good idea to drink lots of water and avoid alcohol, nicotine, and fast
                  food. Exercise can also elevate your blood pressure. On the day of the exam, don't consume any
                  caffeine and drink lots of water to stay hydrated. You'll also need a photo ID, the names and dosages
                  of any medications you take, as well as the name and contact information of your primary care
                  physician.
                </li>
              </ul>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I schedule my medical exam?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Once you sign the application, you should receive a phone call or email to schedule an appointment with
                one of our partners, APPS or Exam One (a Quest Diagnostics Company). Simply pick a date/time that is
                convenient for you and an examiner will either come to your home or your work, or you can go to any
                Quest Labs location.
              </p>
              <p class="faq-item__body-text">
                If you do not receive a call or an email within 2 business days, please let us know!
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How soon do I need to complete my medical exam?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you received temporary coverage: You will have 90 days to complete your medical exam from the time
                you submit your application. You have temporary coverage* during this entire time frame unless notified
                otherwise.
              </p>
              <p class="faq-item__body-text">
                If you didn't receive temporary coverage: You will have 30 days to complete your medical exam from the
                time you submit your application.
              </p>
              <p class="faq-item__body-text">
                *Coverage only begins if your payment is received and is limited to up to $1,000,000 during this
                temporary coverage period.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How much could my price change after my medical exam?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you filled out your application accurately, there typically shouldn't be a change to the price we
                offered. There could potentially be information found in the medical exam that would cause either a
                price increase, decrease, or a decline of coverage.
              </p>
            </div>
          </details>

          <details class="faq-item" *ngIf="allowReapply">
            <summary class="faq-item__question">
              May I cancel my policy if my price goes up after my medical exam?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, you can cancel your application at any point during the process and get a full refund. You can also
                re-apply for a lower level of coverage if the price is too costly. Don't worry, you won't need to retake
                the medical exam and your application information will be saved. (If you were approved for temporary
                coverage and cancel your application, you will lose your temporary coverage).
              </p>
            </div>
          </details>

          <details class="faq-item" *ngIf="!allowReapply">
            <summary class="faq-item__question">
              May I cancel my policy if my price goes up after my medical exam?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, you can cancel your application at any point during the process and get a full refund.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Could I be declined for coverage?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, there is a possibility you will be declined coverage. If new information becomes available or
                misinformation was provided in the application that later becomes known, MassMutual reserves the right
                to decline coverage at any point before offering you a full policy.
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="temporary-coverage">
          <a name="temporary-coverage">
            <h2 class="faq__section-title">Temporary Coverage</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">What is temporary coverage?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                It provides coverage for up to $1,000,000 while you take the medical exam and lasts either until you
                receive full coverage, you decide to cancel your application, or your application is declined. If you
                accept the policy your temporary coverage payment will be applied towards your first month of full
                coverage, and if you do not accept or get declined, you will receive a full refund.
              </p>
              <p class="faq-item__body-text">
                It is critical that your payment is received in order to have temporary coverage. If your payment does
                not go through, then you will not be covered, so make sure to enter correct banking information and have
                money in the account.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How does your temporary coverage work?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">Here is a quick summary of how the temporary coverage works:</p>
              <ul class="faq__list">
                <li>It is available based on our algorithmic underwriting process guidelines.</li>
                <li>
                  If approved, you are covered for up to $1,000,000 until either your full coverage is in effect or the
                  application is cancelled/declined.
                </li>
                <li>It gives you 90 days to complete a medical exam.</li>
                <li>
                  It requires one month of payment* based on the health class and rate estimated by the algorithm for
                  the full amount of coverage you applied for.**
                </li>
                <li>
                  The payment is applied to your first month of full coverage if you accept, or refunded if you don't
                  accept.
                </li>
              </ul>
              <p class="faq-item__body-text">*Excluding any Waiver of Premium, if selected.</p>
              <p class="faq-item__body-text">
                **The minimum payment required in order to provide you with temporary life insurance coverage of
                $1,000,000 must be equal to a one-month premium under the full amount of the policy applied for. In the
                event that a death benefit is due during the temporary coverage period, MassMutual will return to the
                owner any excess amount of premium paid above the $1,000,000 of death benefit due.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How long will my temporary coverage last?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Temporary coverage will last until you receive full coverage or are notified that your application is
                cancelled/declined. Applications are generally cancelled/declined if you didn't take your medical exam
                in time (90 days), you didn't accept our offer in time, you cancelled the application, or our
                underwriters determined that you were not approved for a MassMutual Convertible Term or Whole Life
                policy.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              What if something happens to me before my permanent full coverage is in place?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                As long as you filled out the application accurately and your payment is received, you have temporary
                coverage for up to $1,000,000 while we gather the information necessary to make a final offer.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">
              How much will you charge me during the temporary coverage period?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Only after you digitally sign the application will there be an initial, one-time draft from your bank
                account based on the expected monthly premium* for the full amount of coverage you applied for**. This
                charge will cover you for up to $1,000,000 in coverage through the underwriting process and will be
                applied towards your first month of full coverage. If you decide to cancel at any point during the
                process of getting full coverage, you will get a full refund and your temporary coverage will be
                cancelled.
              </p>
              <p class="faq-item__body-text">*Excluding any Waiver of Premium, if selected.</p>
              <p class="faq-item__body-text">
                **The minimum payment required in order to provide you with temporary life insurance coverage of
                $1,000,000 must be equal to a one-month premium under the full amount of the policy applied for. In the
                event that a death benefit is due during the temporary coverage period, MassMutual will return to the
                owner any excess amount of premium paid above the $1,000,000 of death benefit due.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Why is my initial charge lower than the recurring charges?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The initial charge is to provide temporary coverage for up to $1,000,000 until a final underwriting
                decision is made based on your medical exam. Your initial charge may be lower for two reasons:
              </p>
              <ol>
                <li>
                  Temporary coverage does not include the Waiver of Premium as this option is only on full coverage.
                  Therefore, when you accept your full coverage, it will include the base premium plus the Waiver of
                  Premium.
                </li>
                <li>
                  There could potentially be information found in the medical exam that would cause a premium increase.
                  If this is the case, you will be notified and will need to approve before we would draft from your
                  account again.
                </li>
              </ol>
            </div>
          </details>
        </section>

        <section class="faq__section" id="payments">
          <a name="payments">
            <h2 class="faq__section-title">Payments</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">When will you draft my first payment?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Once you submit your application, you will be notified whether your initial coverage is approved. In
                that case, once you sign the application, your first payment will be drafted immediately. Otherwise, we
                will draft your payment only when we make our final decision and you decide to accept it.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">When and how often will I be charged?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">If you received temporary coverage:</p>
              <ul>
                <li>
                  There will be an initial draft based on the expected monthly premium* for the full amount of coverage
                  you applied for**. This draft will cover you for up to $1,000,000 through the application process and
                  will be applied towards your first month of full coverage. If you decide to cancel at any point during
                  the process or your application is denied, you will receive a full refund and your temporary coverage
                  will be cancelled.
                </li>
              </ul>
              <p class="faq-item__body-text">If you didn't receive temporary coverage:</p>
              <ul>
                <li>
                  You will not be charged initially. Once you complete your medical exam and it is reviewed, we will
                  determine your final underwriting results. If approved, you will receive an offer of your final
                  pricing. If you choose to accept our offer, you will be charged on that day and your full coverage
                  will begin.
                </li>
              </ul>
              <p class="faq-item__body-text">Full coverage:</p>
              <ul>
                <li>
                  When a policy is in-force, a payment will be drafted based on the "anniversary" of your policy
                  effective date.
                </li>
              </ul>
              <p class="faq-item__body-text">*Excluding any Waiver of Premium, if selected.</p>
              <p class="faq-item__body-text">
                **The minimum payment required in order to provide you with temporary life insurance coverage of
                $1,000,000 must be equal to a one-month premium under the full amount of the policy applied for. In the
                event that a death benefit is due during the temporary coverage period, MassMutual will return to the
                owner any excess amount of premium paid above the $1,000,000 of death benefit due.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Will my premium ever change?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                No, our MassMutual Convertible Term policy provides guaranteed level premiums for the selected period of
                time, which means, you will be paying the same premium amount. If you choose to renew it past the
                selected period of time, however, premiums will likely go up.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What happens if I miss a payment?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you miss a premium payment, don't worry, there is a "Grace Period". You will have a 31-day grace
                period in which you can provide new banking information for the premium, with no interest charged, and
                get back on track. You will be reminded multiple times if a payment doesn't go through, but if after 31
                days no payment is received, your policy will be terminated.
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="policy">
          <a name="policy">
            <h2 class="faq__section-title">Your Policy</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">
              Will my policy amount or the number of years I am covered ever change?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The amount you pay during the selected term period will never change. As long as you pay your premium,
                you are guaranteed coverage for the number of years you selected. Once your term ends and if you decide
                to renew, the premium amount could increase.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Can I change my mind or cancel my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                Yes, you can cancel your application at any point during the process. Even if you accept the policy, you
                still have a 10 day "Free Look" period to cancel, with a full refund of premium. Once your full policy
                is in effect you may also cancel at any point, but you won't be refunded for prior coverage and premiums
                paid.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">What is a free look provision?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                By law, you have 10 days (or 30 days if a replacement) from when the policy is accepted to decide if you
                want it. Use this time to read through the contract, and if you would like to cancel, for whatever
                reason, you can do so with a complete refund of premium.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I cancel my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you would like to cancel your policy at any time, follow these steps below:
              </p>
              <ol>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Cancel Policy" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Complete the form via DocuSign, sign, and click "Finish".</li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to 1-855-204-8024, or
                mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                If you need help or have any questions please feel free to call us at:
                <a href="tel:1-844-611-1027">1-844-611-1027</a>
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="change-policy">
          <a name="change-policy">
            <h2 class="faq__section-title">Changing Your Policy</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">How do I change my banking information?</summary>
            <div class="faq-item__answer">
              <ol>
                <li>
                  If you are staying with the same bank, but changing accounts, you can call us at
                  <a href="tel:1-866-618-7797">1-866-618-7797</a>
                  to quickly change accounts.
                </li>
                <li>
                  If you are switching banks, we require a form to be submitted. In order to do so, follow these steps
                  below:
                </li>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Change Payment Method" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Complete the form via DocuSign by providing your banking information.</li>
                <li>Once the form is completed, sign, and click "Finish".</li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to 1-855-204-8024, or
                mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                Please feel free to give us a call at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                if you need help or have any questions.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I change the address on my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The policy owner can either call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                or simply follow these steps below:
              </p>
              <ol>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Change Mailing Address" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Complete the form via DocuSign, sign, and click "Finish".</li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to
                <a href="tel:1-855-204-8024">1-855-204-8024</a>
                , or mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                Please feel free to give us a call at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                if you need help or have any questions.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I change a name on my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you would like to change the name of the owner, insured, or beneficiaries, the policy owner would
                need to complete the Service Request Form (Name Change) by following these steps below:
              </p>
              <ol>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Change Name" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Complete the form via DocuSign, sign, and click "Finish".</li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to
                <a href="tel:1-855-204-8024">1-855-204-8024</a>
                , or mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                If you need help or have any questions please feel free to call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                .
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I change the beneficiaries on my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The policy owner can change the beneficiary (or beneficiaries) at any time by completing the Beneficiary
                Change form. In order to do so, follow these steps below:
              </p>
              <ol>
                <li>
                  Determine the desired beneficiary designation, and obtain the beneficiary(ies) personal information
                  (full name, SSN, DOB, address, contact number).
                </li>
                <li>Go to "Policy Changes" in the Account Center and select the "Change Beneficiary" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Print out a hard copy of the form, fill out, and sign.</li>
                <li>
                  Once completed, you may scan and attach it to the document to submit, fax it to
                  <a href="tel:1-855-204-8024">1-855-204-8024</a>
                  , or mail to the following address:
                </li>
              </ol>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                If you need help or have any questions please feel free to call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                .
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I change the ownership of my policy?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The owner designation on the policy can be either the insured or the insured's partner, fianc&eacute;e,
                or spouse.
              </p>
              <p class="faq-item__body-text">
                The current policy owner would need to complete the Owner Change Request form by following these steps
                below:
              </p>
              <ol>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Change Owner" option.</li>
                <li>
                  You will be prompted to enter the new owner's name and email address. Once entered, you will be
                  prompted to enter an access code to view the document. Please check your email to obtain the access
                  code.
                </li>
                <li>Complete the form via DocuSign, sign, and click "Finish".</li>
                <li>
                  The form will be sent to the new owner to provide their personal information, sign, and click "Finish"
                  to enact the change.
                </li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to
                <a href="tel:1-855-204-8024">1-855-204-8024</a>
                , or mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                If you need help or have any questions please feel free to call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                .
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Can I lower the coverage amount of my policy? If so, how?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                The policy owner has the ability to lower the face amount of the policy one year after the purchase of
                the policy.
              </p>
              <p class="faq-item__body-text">In order to so, follow these steps below:</p>
              <ol>
                <li>Go to "Policy Changes" in the Account Center.</li>
                <li>Select the "Change Face Amount" option.</li>
                <li>
                  You will be prompted to enter an access code to view the document. Please check your email to obtain
                  the access code.
                </li>
                <li>Complete the form via DocuSign, sign, and click "Finish".</li>
              </ol>
              <p class="faq-item__body-text">
                If you prefer to mail/fax the form, you may print it out and once complete, fax it to
                <a href="tel:1-855-204-8024">1-855-204-8024</a>
                , or mail to the following address:
              </p>
              <p class="faq-item__body-text">
                Massachusetts Mutual Life Insurance Company
                <br />
                60 Madison Avenue, 7th Floor
                <br />
                New York, NY 10010
              </p>
              <p class="faq-item__body-text">
                If you need help or have any questions please feel free to call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                .
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Can I remove a Waiver of Premium fee?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">Yes, you can remove a waiver of premium at any point.</p>
              <p class="faq-item__body-text">
                To do so please call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                and it will be removed from all future payments.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">Can I remove Flat Extras?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">Yes, you may remove flat extras subject to approval.</p>
              <p class="faq-item__body-text">
                As you are paying for a policy based on certain activities that are considered to be dangerous (and make
                your premium more expensive), if you are no longer participating in these activities for quite some time
                (typically one year), you can apply to have your case reviewed and the flat extra potentially removed.
              </p>
              <p class="faq-item__body-text">
                If you would like to do this, please call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                .
              </p>
            </div>
          </details>
        </section>

        <section class="faq__section" id="claims">
          <a name="claims">
            <h2 class="faq__section-title">Claims</h2>
          </a>

          <details class="faq-item">
            <summary class="faq-item__question">
              I purchased a Waiver of Premium rider. How do I report a disability?
            </summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                If you have purchased a Waiver of Premium rider on your policy and you are disabled please call us at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                to report your disability.
              </p>
            </div>
          </details>

          <details class="faq-item">
            <summary class="faq-item__question">How do I report a death?</summary>
            <div class="faq-item__answer">
              <p class="faq-item__body-text">
                In the unfortunate event of a death, beneficiaries should call the policy service center at
                <a href="tel:1-866-618-7797">1-866-618-7797</a>
                and select the claims department to be assisted immediately.
              </p>
            </div>
          </details>
        </section>
      </div>
    </section>
  </div>
  <genesys-constellation [participantData]="genesysParticipantData"></genesys-constellation>
</div>
